import { translate } from "utils/string-table";

import { Button } from "~components/Molecules";

type FooterProps = {
  disabled?: boolean;
  onSubmit: () => void;
  onCancel: () => void;
};

/**
 * @description Contains submit and cancel buttons
 */
export function Footer(props: FooterProps) {
  const { disabled, onSubmit, onCancel } = props;

  return (
    <footer>
      <div css={{ marginTop: 16, marginBottom: 16 }}>
        <Button
          type="PRIMARY"
          label={translate("SAVE_CHANGES")}
          onClick={onSubmit}
          isFluid
          isDisabled={disabled}
        />
      </div>
      <Button type="SECONDARY" label={translate("LABEL_CANCEL")} isFluid onClick={onCancel} />
    </footer>
  );
}
